<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Recursos disponíveis" />
    <menuLateral />

    <ContratoModalVerificaCancelamento
      v-if="informacoesContrato"
      :resumoContrato="informacoesContrato"
      :isVencido="isVencido"
      :modalCancelamento="$refs.contratoModalCancelamento"
      ref="contratoModalVerificaCancelamento"
    />

    <ContratoModalCancelamento
      v-if="informacoesContrato"
      :resumoContrato="informacoesContrato"
      :isVencido="isVencido"
      @obterResumoContrato="obterRecursos"
      ref="contratoModalCancelamento"
    />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid"></div>
        <!-- /.container-fluid -->
      <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
      </section>
      <!-- Main content -->

      <section class="content recursos px-4"  v-if="!flagsDeControle.carregandoDados.status">

         <!-- Aqui é cancelamento do contrato principal -->
         <div v-if="informacoesContrato.pedido_cancelamento && informacoesContrato.data_cancelamento == null">
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
              Seu plano atual permanecerá ativo até o dia {{ informacoesContrato.data_vencimento_por_extenso }}, devido ao cancelamento realizado. Após essa data, você perderá acesso aos serviços e recursos vinculados a este plano.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
         </div>

         <div v-if="temFaturaEmAtrasoDoContratoPrincipal">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
              O Plano Mirt está atrasado. Para evitar bloqueios ou transtornos futuros, por favor regularize a situação.
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!-- Default box -->
        <div v-if="recursos.length === 0" class="alert alert-info text-center">
          Nenhum recurso disponível.
        </div>
        <div v-else class="card">
          <div class="card-body p-0">
            <div class="row p-3 mt-3">
              <!-- Inicio Desktop -->
              <div class="d-none d-xl-block d-lg-block col-6 text-left">
                <h2>Recursos Disponíveis</h2>
              </div>
              <!-- Fim Desktop -->
              <!-- Inicio Desktop -->
              <div class="d-none d-xl-block d-lg-block col-6 text-right">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-6">
                        <p class="text-muted">Mensalidade:</p>
                      </div>
                      <div class="col-6">
                        <p><b>{{ formatarValorMonetario(this.informacoesContrato.valor_mensalidade) }}</b></p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-6 text-right">
                        <p class="text-muted">Próximo Vencimento:</p>
                      </div>
                      <div class="col-6">
                        <p class="text-muted">{{ $date(this.informacoesContrato.data_vencimento_proximo_mes).format('DD/MM/YYYY') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fim Desktop -->
              <!-- Inicio Mobile -->
              <div class="d-sm-block d-xl-none d-lg-none col-12 text-left">
                <div class="row px-3">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-6 text-left">
                        <p class="text-muted">Mensalidade:</p>
                      </div>
                      <div class="col-6 text-right">
                        <p><b>{{ formatarValorMonetario(this.informacoesContrato.valor_mensalidade) }}</b></p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-7 text-left">
                        <p class="text-muted">Próximo Vencimento:</p>
                      </div>
                      <div class="col-5 text-right">
                        <p class="text-muted">{{ $date(this.informacoesContrato.data_vencimento_proximo_mes).format('DD/MM/YYYY') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fim Mobile -->
            </div>
              <RecursosListagem :recursos="recursos" :modalVerificaCancelamento="$refs.contratoModalVerificaCancelamento" :esconderBotaoCancelar="false" :esconderBotaoAdicionar="false" />
            </div>

        </div>
        <div class="row">
                <div class="col-12 text-right">
                  Exclua sua conta e todos os seus dados <span @click="
                              $refs.contratoModalVerificaCancelamento.abrirModalVerificaCancelamento(
                                informacoesContrato.id,
                                '1',
                                informacoesContrato
                              )
                            " class="highlight">clicando aqui</span>
                </div>
              </div>
      </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Recursos from './js'
export default Recursos
</script>

<style scoped>
@import "./scss/recurso.scss";
</style>
